module.exports = __webpack_public_path__ + "img/quick-reply_radar_no-data.0258a31d.png";